// extracted by mini-css-extract-plugin
export var active = "_my-2";
export var recordingDot = "_my-1";
export var recordingIndicator = "_my-0";